import type { ComponentProps } from "react"

export default function PropertyEducation(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <g clipPath="url(#clip0_11813_260)">
        <path
          d="M20 1.80399V6.66666H24.8627C23.692 4.65067 22.016 2.97468 20 1.80399ZM26.6667 13.3333C26.6669 11.9765 26.4596 10.6275 26.052 9.33333H20V13.3333H26.6667ZM9.33333 26.052C10.6274 26.4603 11.9764 26.6676 13.3333 26.6667V20H9.33333V26.052ZM17.3333 9.33333H9.33333V17.3333H13.3333V14.6667C13.3333 14.313 13.4738 13.9739 13.7239 13.7239C13.9739 13.4738 14.313 13.3333 14.6667 13.3333H17.3333V9.33333ZM1.86999e-07 13.3333C-0.000227275 14.6902 0.207058 16.0391 0.614667 17.3333H6.66667V9.33333H0.614667C0.207058 10.6275 -0.000227275 11.9765 1.86999e-07 13.3333ZM6.66667 24.8613V20H1.804C2.97433 22.0159 4.65043 23.6916 6.66667 24.8613ZM1.804 6.66666H6.66667V1.80399C4.65068 2.97468 2.97469 4.65067 1.804 6.66666ZM17.3333 0.614659C14.7296 -0.204887 11.937 -0.204887 9.33333 0.614659V6.66666H17.3333V0.614659ZM31.324 16.1733C31.1188 16.0561 30.886 15.9959 30.6496 15.999C30.4133 16.002 30.1821 16.0682 29.98 16.1907L24 19.7787L18.02 16.1907C17.8177 16.0691 17.5868 16.0035 17.3508 16.0004C17.1148 15.9973 16.8823 16.0569 16.6769 16.1731C16.4714 16.2893 16.3006 16.4579 16.1816 16.6617C16.0627 16.8656 16 17.0973 16 17.3333V26.6667C16 26.8967 16.0596 27.1229 16.1729 27.3231C16.2863 27.5233 16.4495 27.6908 16.6467 27.8093L23.3133 31.8093C23.5207 31.9339 23.7581 31.9997 24 31.9997C24.2419 31.9997 24.4793 31.9339 24.6867 31.8093L31.3533 27.8093C31.5505 27.6908 31.7137 27.5233 31.8271 27.3231C31.9404 27.1229 32 26.8967 32 26.6667V17.3333C32 17.0975 31.9374 16.8658 31.8187 16.662C31.6999 16.4582 31.5292 16.2896 31.324 16.1733ZM18.6667 19.688L22.6667 22.088V28.312L18.6667 25.912V19.688ZM29.3333 25.912L25.3333 28.312V22.088L29.3333 19.688V25.912Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_11813_260">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
